export default "__VITE_ASSET__aSVDDkQv__"